var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7515 0H47.7512C21.3789 0 0 21.379 0 47.7512V47.7513C0 74.1235 21.3789 95.5025 47.7512 95.5025H47.7515C74.1238 95.5025 95.5027 74.1235 95.5027 47.7513V47.7512C95.5027 21.379 74.1238 0 47.7515 0Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7528 10.6074H47.7527C27.2409 10.6074 10.6128 27.2355 10.6128 47.7473C10.6128 68.259 27.2409 84.8871 47.7527 84.8871H47.7528C68.2646 84.8871 84.8927 68.259 84.8927 47.7473C84.8927 27.2355 68.2646 10.6074 47.7528 10.6074Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.082 60.7963C31.082 53.6023 35.631 47.4602 42.036 45.0342V42.1193C42.036 39.1253 45.185 36.6973 48.122 36.6973C51.059 36.6973 54.207 39.1253 54.207 42.1193V45.0342C60.612 47.4602 65.161 53.6023 65.161 60.7963H31.082Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2138 59.1527C25.3058 59.1527 24.5708 59.8877 24.5708 60.7957C24.5708 61.7027 25.3058 62.4387 26.2138 62.4387V59.1527ZM70.0288 62.4387C70.9368 62.4387 71.6728 61.7027 71.6728 60.7957C71.6728 59.8877 70.9368 59.1527 70.0288 59.1527V62.4387ZM32.7248 60.7957C32.7248 54.3147 36.8228 48.7657 42.6178 46.5707L41.4538 43.4977C34.4388 46.1537 29.4388 52.8887 29.4388 60.7957H32.7248ZM42.6178 46.5707C44.3248 45.9247 46.1788 45.5697 48.1218 45.5697V42.2837C45.7758 42.2837 43.5268 42.7127 41.4538 43.4977L42.6178 46.5707ZM48.1218 45.5697C50.0638 45.5697 51.9188 45.9247 53.6248 46.5707L54.7888 43.4977C52.7158 42.7127 50.4668 42.2837 48.1218 42.2837V45.5697ZM53.6248 46.5707C59.4208 48.7657 63.5178 54.3147 63.5178 60.7957H66.8038C66.8038 52.8887 61.8038 46.1537 54.7888 43.4977L53.6248 46.5707ZM43.6788 42.1187C43.6788 41.2197 44.1558 40.2897 45.0418 39.5367C45.9308 38.7817 47.0828 38.3397 48.1218 38.3397V35.0537C46.2238 35.0537 44.3328 35.8267 42.9128 37.0337C41.4908 38.2427 40.3928 40.0237 40.3928 42.1187H43.6788ZM48.1218 38.3397C49.1608 38.3397 50.3128 38.7817 51.2018 39.5367C52.0868 40.2897 52.5638 41.2197 52.5638 42.1187H55.8498C55.8498 40.0237 54.7528 38.2427 53.3298 37.0337C51.9098 35.8267 50.0198 35.0537 48.1218 35.0537V38.3397ZM52.5638 42.1187V45.0337H55.8498V42.1187H52.5638ZM52.5638 45.0337V45.1317H55.8498V45.0337H52.5638ZM40.3928 42.1187V45.0337H43.6788V42.1187H40.3928ZM40.3928 45.0337V45.1317H43.6788V45.0337H40.3928ZM26.2138 62.4387H31.0818V59.1527H26.2138V62.4387ZM31.0818 62.4387H65.1608V59.1527H31.0818V62.4387ZM65.1608 62.4387H70.0288V59.1527H65.1608V62.4387Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1212 27.9351V25.7441M57.9802 30.2621L55.9252 32.3161M40.3172 32.3161L38.2632 30.2621",
    stroke: "black",
    strokeWidth: 3.28617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 9.972,
    y1: 4.2,
    x2: 100.691,
    y2: 24.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.412705572e3ecd35a51a3550af9afa9b.svg";
export { ForwardRef as ReactComponent };